import { ZiroIcons as ziroIcons } from '../../../shared/models/ziro-icons.enum';

export const getStringFromProcessingStatus = (processingStatus: string): string => {
  switch (processingStatus) {
    case 'COMPLETE': {
      return 'Completed';
    }
    case 'CANCELLED': {
      return 'Cancelled';
    }
    case 'SUBMITTED': {
      return 'Submitted';
    }
    case 'REQUESTED_SUPP': {
      return 'Support Requested';
    }
    case 'REQUESTED_CANCEL': {
      return 'Cancellation Requested';
    }
    case 'FOC': {
      return 'FOC Date Confirmed';
    }
    case 'DRAFT':
    case 'draft': {
      return 'Draft';
    }
    case 'EXCEPTION': {
      return 'Exception';
    }
    default: {
      return processingStatus.replaceAll('_', ' ').toLowerCase();
    }
  }
};

export const getProcessingStatusHtml = (processingStatus: string): string => {
  return `<span class="alert alert-inline alert-info text-capitalize"> ${getProcessingStatusIcon(
    processingStatus,
  )} ${getStringFromProcessingStatus(processingStatus)}</span>`;
};

const getProcessingStatusIcon = (processingStatus: string): string => {
  switch (processingStatus) {
    case 'COMPLETE': {
      return `<i class="${ziroIcons.CIRCLE_CHECK_SOLID} text-success"></i>`;
    }
    case 'CANCELLED': {
      return `<i class="${ziroIcons.UNAVAILABLE} text-danger"></i>`;
    }
    case 'SUBMITTED': {
      return `<i class="${ziroIcons.SEND_EMAIL} text-primary"></i>`;
    }
    case 'REQUESTED_SUPP': {
      return `<i class="${ziroIcons.AGENT_SMALL} text-warning"></i>`;
    }
    case 'REQUESTED_CANCEL': {
      return `<i class="${ziroIcons.AGENT_SMALL} text-danger"></i>`;
    }
    case 'FOC': {
      return `<i class="${ziroIcons.CALENDAR_DAY_SMALL} text-primary"></i>`;
    }
    case 'EXCEPTION': {
      return `<i class="${ziroIcons.WARNING_TRIANGLE} text-danger"></i>`;
    }
    case 'DRAFT': {
      return `<i class="${ziroIcons.DRAFT} text-warning"></i>`;
    }
    default: {
      return '';
    }
  }
};
